import { parse } from 'date-fns';
import { paramsListArr } from '../Assets/Constants/json_constants';
import { DeleteRefreshToken, FetchMenuDetails, GetGrouping } from '../Services/APIConfig';
import { resetAuth, updateUserInfo, updateUserSetting } from '../Store/AuthSlice/AuthSlice';

export const checkAccessPermissions = (userData, requiredPermission) => {
  let hasPermission = true;
  if (requiredPermission) {
    hasPermission = userData?.roles?.some(role =>
      role?.permissions?.some(permission => permission.permission_name === requiredPermission)
    );
  }

  return hasPermission;
};

export const validateMobileNumber = value => value.replace(/[^0-9]/g, '').replace(/^[0-5]/, '');
export const validatePincode = value => value.replace(/[^0-9]/g, '').replace(/^[0]/, '');
export const validateName = value =>
  value
    .trimStart()
    .replace(/[^a-zA-Z\s]/g, '')
    .replace('  ', ' ');

export const validateAphaNumberUpperCase = value => value.replace(/[^a-zA-Z0-9]/g, '');
export const validateAphaNumber = value =>
  value
    .trimStart()
    .replace(/[^a-zA-Z0-9\s.,#&-]/g, '')
    .replace('  ', ' ');
export const validateEmailLowerCase = value => value.trimStart().toLowerCase().replace(' ', '');
export const validateCity = value => value.trimStart().replace(/[^a-zA-Z]/g, '');

export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = window.atob(b64Data.replace(/^data:image\/(png|jpeg|jpg);base64,/, ''));
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });

  return blob;
};

export function downloadBase64File(contentBase64, fileName, type, fileType = 'application') {
  let linkSource = '';
  if (type == 'csv') {
    const decodedData = atob(contentBase64);

    const uint8Array = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
      uint8Array[i] = decodedData.charCodeAt(i);
    }

    const blob = new Blob([uint8Array], { type: 'text/csv' });

    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);

    downloadLink.click();
    document.body.removeChild(downloadLink);
  } else {
    if (type == 'pdf') {
      linkSource = contentBase64;
    } else {
      linkSource = `data:${fileType}/${type};base64,${contentBase64}`;
    }

    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    downloadLink.href = linkSource;
    downloadLink.target = '_self';
    downloadLink.download = fileName;
    downloadLink.click();
  }
}
export function downloadXlsxFile(contentBase64, fileName) {
  try {
    // Decode the base64 string
    const decodedData = atob(contentBase64);
    const uint8Array = Uint8Array.from(decodedData, char => char.charCodeAt(0));

    // Create a Blob with MIME type for .xlsx files
    const blob = new Blob([uint8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const linkSource = URL.createObjectURL(blob);

    // Create a download link and trigger the download
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    // Revoke the object URL to free up memory
    URL.revokeObjectURL(linkSource);
  } catch (error) {
    console.error('Failed to download the .xlsx file:', error);
  }
}

export const fetchMenuDetails = async dispatch => {
  const response = await FetchMenuDetails();
  if (response?.status === 200) {
    let menu = response?.result?.[0].permissions;

    dispatch(
      updateUserInfo({
        menu: menu,
        userId: response?.result?.[0].userId,
        brandingChange: false,
        profileImageChanged: true,
        branding: response?.result?.[0].branding,
        orgId: response?.result?.[0].orgId,
        userName: response?.result?.[0].userName,
        userType: response?.result?.[0].userType,
        isAdmin: response?.result?.[0]?.isSuperAdmin,
        approvalEsignFlow: response?.result?.[0]?.approvalEsignFlow
      })
    );
  }
  return response;
};

export const fetchDataGrpName = async dispatch => {
  const response = await GetGrouping();
  if (response?.status === 200) {
    let groupName = '';
    let val = response.result?.find(val => val.enableGroup === true);
    if (val?.groupName.toLowerCase() == 'custom') {
      groupName = val?.alias;
    } else {
      groupName = val?.groupName;
    }

    let param = [];

    paramsListArr.forEach(data => {
      let saveObj = {
        id: data?.id,
        title: data?.title,
        type: data?.type,
        width: data?.width,
        placeholder: data?.placeholder,
        regexPattern: data?.regexPattern,
        error: data?.error,
        value: data?.value
      };
      if (val?.[data?.title?.toLowerCase() + 'Required'] !== undefined) {
        saveObj = {
          ...saveObj,
          required: val?.[data?.title?.toLowerCase() + 'Required']
        };
      }
      if (val?.[data?.title?.toLowerCase() + 'Enabled'] !== undefined) {
        saveObj = {
          ...saveObj,
          visible: val?.[data?.title?.toLowerCase() + 'Enabled']
        };
      }

      let obj = {};
      obj.id = saveObj.id;
      obj.title = saveObj.title;
      obj.required = saveObj.required;
      obj.visible = saveObj.visible;
      obj.type = saveObj.type;
      obj.width = saveObj.width;
      obj.placeholder = saveObj.placeholder;
      obj.regexPattern = saveObj.regexPattern;
      obj.error = saveObj.error;
      obj.value = saveObj.value;

      param.push({ ...obj });
    });

    dispatch(
      updateUserSetting({
        group: groupName,
        paramsArr: param
      })
    );
    return groupName;
  } else {
    console.log('ERROR fetchRoles', response?.error);
  }
};

export const parseJwt = token => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

export function areStartingLettersCapital(str) {
  const regex = /\b[A-Z]/g;
  return regex.test(str);
}

export const transformToCapitalise = value => {
  if (value) {
    return value
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  } else {
    return '';
  }
};

export const transformOneWordToCapitalise = value => {
  return value
    ? value
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : '';
};

export const getTimeFromDate = value => {
  let date = new Date(value);
  if (!isNaN(date.getTime())) {
    return date?.toISOString()?.split('T')[1]?.split('.')[0];
  } else {
    return null;
  }
};

export const getDateOnly = value => {
  let date = new Date(value);
  if (!isNaN(date.getTime())) {
    return date?.toLocaleDateString();
  } else {
    return null;
  }
};

export const isValidDate = date => {
  return !isNaN(Date.parse(date));
};

const deleteRefreshToken = async () => {
  const response = await DeleteRefreshToken(localStorage.getItem('refreshToken'));
  if (response?.status === 200) {
    // console.log(response);
  }
};
export const handleLogoutUtil = async (dispatch, navigate) => {
	navigate('/login');
	localStorage.removeItem('authToken');
	// localStorage.removeItem('loggedInUserId');
	localStorage.removeItem('refreshToken');
	dispatch(resetAuth());
};

export const convertDateStringToDate = dateString => {
  const isAMPMFormat = dateString.includes('PM') || dateString.includes('AM');

  const formatOptions = isAMPMFormat ? 'hh:mm a, MMM do, yyyy' : 'MMM do, yyyy';

  try {
    const parsedDate = parse(dateString, formatOptions, new Date());
    return parsedDate;
  } catch (error) {
    console.error('Error parsing date:', error);
    return null;
  }
};

export const debounce = (func, delay) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export const getErrorMessage = (
	response,
	defaultMessage = 'Something went wrong'
) => {
	const message
		= response?.message
		|| response?.error?.errorMessage
		|| response?.error
		|| defaultMessage;
	return message;
};


export const getTruthyValue = (condition, trueValue = '', falseValue = '') => {
	if (condition) {
		return trueValue;
	}

	return falseValue;
};

export const isImageFile = (url) => {
	const imageExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.webp'];
	
	const hasImageExtension = imageExtensions.some(ext => url?.toLowerCase().endsWith(ext));

	const isBase64Image = /^data:image\/(png|jpg|jpeg|gif|bmp|webp);base64,/.test(url);
	return hasImageExtension || isBase64Image;
};
